;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/details/:cycleId\",\"regex\":\"^/details/([^/]+)$\",\"paramNames\":[\"cycleId\"],\"hasOptionalPrefix\":false},{\"path\":\"/squareoff-review/:cycleId\",\"regex\":\"^/squareoff-review/([^/]+)$\",\"paramNames\":[\"cycleId\"],\"hasOptionalPrefix\":false},{\"path\":\"/status/:cycleId\",\"regex\":\"^/status/([^/]+)$\",\"paramNames\":[\"cycleId\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/account\"},{\"path\":\"/configure\"},{\"path\":\"/contact-details\"},{\"path\":\"/get-started\"},{\"path\":\"/learn\"},{\"path\":\"/learn/glossary\"},{\"path\":\"/past-basket\"},{\"path\":\"/review\"},{\"path\":\"/status/success\"},{\"path\":\"/subscribe\"},{\"path\":\"/login\"},{\"path\":\"/sentry-test\"},{\"path\":\"/sso\"},{\"path\":\"/maintenance\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.6";import * as Sentry from '@sentry/nextjs';
Sentry.init({
    dsn: 'https://cb23c9977514380efddb4e2c5a556d69@o4504241437212672.ingest.us.sentry.io/4509191476805632',
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    environment: process.env.NEXT_PUBLIC_ENV || 'production',

    integrations: [
        //  session-replay
        // Replay may only be enabled for the client-side
        Sentry.replayIntegration({
            maskAllInputs: false,
            maskAllText: false,
        }),

        //  session-replay
    ],
    //  logs
    // Enable logs to be sent to Sentry

    enableLogs: true,
    //  logs
    //  performance
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: 0,

    //  performance
    //  session-replay
    // Capture Replay for 10% of all
    // plus for 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    //  session-replay
});
//  performance
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
//  performance
